import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

const FieldSection: React.FC<BoxProps> = ({ children, ...props }) => (
  <Box
    bg="transparent"
    px={{ base: 4, md: 8 }}
    py={{ base: 6, md: 10 }}
    border="1px solid"
    borderColor="gray.200"
    borderRadius="lg"
    {...props}
  >
    {children}
  </Box>
);

export default FieldSection; 